import { createContext, useContext, useMemo, useState } from 'react';

const GridDataContext = createContext([]);

// TODO: Move grid rows status and added/edited/deleted rows info also here
export default function GridDataContextProvider({ children }) {
  const [rows, updateRows] = useState([]);

  const setRows = (newRows) => {
    updateRows(newRows);
  };

  const value = useMemo(() => [rows, setRows], [rows, setRows]);

  return <GridDataContext.Provider value={value}>{children}</GridDataContext.Provider>;
}

export function useGridDataContext() {
  const context = useContext(GridDataContext);
  if (!context) {
    throw new Error('Context must be used within a Provider');
  }
  return context;
}
